module.exports = __webpack_public_path__ + "static/media/TensorFlow.2044cbd4.svg";